import Text from 'presentation/components/text/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';
import ImageButton from 'presentation/components/image-button/index.js';

const PageTitle = props => {
    const {
        mojitoTools: { config },
        onClick,
        text,
    } = props;

    return (
        <FlexPane config={config.container} class="ta-PageTitle">
            <FlexPane config={config.iconButtonContainer}>
                <ImageButton onClick={onClick} config={config.icon} disabled={!onClick} />
            </FlexPane>
            <Text config={config.text}>{text}</Text>
        </FlexPane>
    );
};

export default PageTitle;
